import { SelectOption } from '@techmore/form';
import { Component, Inject, Injector, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BreadCrumbService } from 'src/app/share/service/bread-crumb.service';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { OptionService } from 'src/app/share/service/option.service';
import { CmsService } from 'src/app/web-generator/cms-generator/service/cms.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { AbstractCmsWeb } from '../../abstract-cms-web';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { ServerConfigService } from 'src/app/share/service/server-config.service';

/** 主題連結版1。 模板是 共構多筆版8 搬過來 */
@Component({
  selector: 'app-web-01',
  templateUrl: './index.component.html',
  styleUrls: [
    './index.component.scss'
  ]
})
export class IndexComponent extends AbstractCmsWeb {
  /** 從關鍵字過濾出的分類 */
  categories = [];

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected cmsService: CmsService,
    protected translate: TranslateService,
    protected optionService: OptionService,
    protected http: CommonHttpClientService,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected injector: Injector,
    protected templateService: TemplateService,
    protected serverConfigService: ServerConfigService,
    @Optional() @Inject(REQUEST) protected request: Request,
    protected breadCrumbService: BreadCrumbService,
  ) {
    super(route, router, cmsService, translate, optionService, http, generatorEnv, platformId, injector, templateService, serverConfigService, request, breadCrumbService);
  }

  dataUpdated() {
    // 取得資料後更新從關鍵字過濾出的分類
    if (this.remoteData)
      this.remoteData.rows.forEach(item => {
        if (item.keywords) {
          item.keywords.forEach(k => {
            const f = this.categories.find(c => c === k);
            if (!f) { this.categories.push(({ label: k, value: k } as SelectOption)) }
          })
        }

      })
  }

  linkHit(id) {
    this.http.get<void>(`${this.generatorEnv.apiHost}/api/${this.translate.currentLang}/cm/web/${this.path}/${id}`).subscribe();
  }
}
